import ComercialPage from "./ComercialPage";
export default ComercialPage;